import { Lock } from '../../components/icons';
import { Typography } from '../../tailwindcomponents';

function NotAuthorized() {
  return (
    <div className="flex min-h-screen flex-col items-center justify-center">
      <div className="w-1/4">
        <Lock fontSize="large" color="error" />
      </div>
      <div className="w-1/3">
        <Typography text="Unauthorized Access" align="center" variant="h1" />
      </div>
      <div className="w-1/4">
        <Typography text="You do not have access to this part of Maintener. Please contact your superior if you believe you should be granted access." margin={[2, 0, 0, 0]} align="center" variant="subtitle1" />
      </div>
    </div>
  );
};
export default NotAuthorized
